import { i18n } from "./lang/setup";

export const parseInviteCodesFromUri = (uriPart) => {
  return (uriPart || "").split("+").filter(i => i != '')
}

export const inviteCodesToUri = (codes) => {
  return codes.map(i => encodeURIComponent(i)).join('+')
}

export function hasMetaValue(metaValues, searchKey) {
  return metaValues && metaValues.find(({ key, locale }) => key == searchKey && locale == i18n.locale) != null;
}

export function getMetaValue(metaValues, searchKey) {
  const metaValue = metaValues && metaValues.find(({ key, locale }) => key == searchKey && locale == i18n.locale);
  return metaValue ? metaValue.value : null;
}

export function formatDate(date, locale = "en") {
  if (date === null || date === undefined || date === '') {
    return date;
  }

  if (isNaN(Date.parse(date))) {
    // the date is invalid, lets return the original value
    return date;
  }

  const d = new Date(date);

  const year = d.toLocaleDateString(locale, { year: 'numeric'});
  const month = d.toLocaleDateString(locale, { month: 'short' });
  const day = d.toLocaleDateString(locale, { day: 'numeric' });
  return `${day} ${month} ${year}`;
}